<script>

import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  components: {
  },
  props: ['workflows'],
  name: 'ProjectByWorkflow',
  data () {
    return {
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false
          }
        }
        // scale: {
        //   reverse: false,
        //   ticks: {
        //     min: 0,
        //     stepSize: 1
        //   }
        // }
        },
      data: {
        datasets: [{
          data: [ 0, 0, 0 ],
          backgroundColor: ['rgba(52, 152, 219, 0.8)', 'rgba(98, 203, 49, 0.5)', 'rgba(30, 107, 10, 0.8)']
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      this.data.datasets[0].data = []
      let workflowValue = []
      let workflowLabels = []

      let max = 0

      Object.keys(this.workflows).forEach((element) => {
        workflowLabels.push(element)
        workflowValue.push(this.workflows[element])
        if (this.workflows[element] > max) {
          max = this.workflows[element]
        }
      })
      // this.options.scale.ticks.max = max + 1
      this.data.datasets[0].data = workflowValue
      this.data.labels = workflowLabels
      this.options.labels = workflowLabels


      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ProjectByWorkflow.vue